import { render, staticRenderFns } from "./MoveOrderToStatusButtonOptions.vue?vue&type=template&id=7115afa2"
import script from "./MoveOrderToStatusButtonOptions.vue?vue&type=script&lang=js"
export * from "./MoveOrderToStatusButtonOptions.vue?vue&type=script&lang=js"
import style0 from "./MoveOrderToStatusButtonOptions.vue?vue&type=style&index=0&id=7115afa2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports